import { GtmUtils } from './gtm-utils';

(function (window, factory) {
  var dLayerFunc = factory(window, window.document);
  window.dLayerFunc = dLayerFunc;
  if (typeof module == 'object' && module.exports) {
    module.exports = dLayerFunc;
  }
}(typeof window != 'undefined' ?
  window : {}, function d(window, document) {
    'use strict';

    var formChanged = false,
      forms = [],
      checkFormChangeEvent,
      pushGTMConsent,
      pushGTMSubmit,
      pushGTMFailed;



    /** initialize function **/
    (function () {
      //initialize variable
      formChanged = false;
      forms = document.querySelectorAll('form[formid]');

      if (forms && forms.length > 0) {

        forms.forEach((el) => {
          // check for change event
          el.addEventListener('change', () => { checkFormChangeEvent(el) });
          // fill out utm fields if present
          var urlStringObj = _getUTMFields(el);
          if (Object.keys(urlStringObj).length !== 0) {
            _fillUTMFields(urlStringObj, el);
          }

        });
      }
    })();


    /** function to fill utm fields in form  */
    function _fillUTMFields(utmObj, formElem) {
      try {

        var utmFields = {};
        utmFields.utm_campaign = formElem.querySelector('input[name=utmCampaign]') || null;
        utmFields.utm_content = formElem.querySelector('input[name=utmContent]') || null;
        utmFields.utm_medium = formElem.querySelector('input[name=utmMedium]') || null;
        utmFields.utm_source = formElem.querySelector('input[name=utmSource]') || null;
        utmFields.utm_term = formElem.querySelector('input[name=utmTerm]') || null;
        utmFields.gclid = formElem.querySelector('input[name=gclid]') || null;


        var utmIndices = ['utm_campaign', 'utm_medium', 'utm_term', 'utm_source', 'utm_content', 'gclid'];

        utmIndices.forEach(function (arrKey) {

          if (utmFields[arrKey] == null && (utmObj.hasOwnProperty(arrKey) && utmObj[arrKey] != 'undefined')) {
            //Object below means basically the url querystring.
            console.log("UTM [" + arrKey + "] exists in Object but a relevant field could not be found in the form!");
          }

          if (utmFields[arrKey] != null && (!utmObj.hasOwnProperty(arrKey) || utmObj[arrKey] == 'undefined')) {
            console.log("A field for UTM [" + arrKey + "] exists, but no property was found in Object.");
          }

          if (utmObj.hasOwnProperty(arrKey) && utmObj[arrKey] != 'undefined' && utmFields[arrKey] != null) {
            utmFields[arrKey].value = utmObj[arrKey];
          }
        });

      } catch (e) { console.error(e.message) }
    }

    /** function to split utm from query string and return as object */
    function _getUTMFields(elem) {

      if (elem.nodeName && elem.nodeName.toLowerCase() == 'form') {

        try {


          var urlStringObj = _utilGetURLParameters();
          if (Object.keys(urlStringObj).length === 0 && urlStringObj.constructor === Object) {
            return {};
          }

          return urlStringObj;


        } catch (e) { console.error('UTM elements not found! Error: ' + e.message) }

      }
    }

    function _utilGetURLParameters() {
      var qString = window.location.search.slice(1);
      var paramObj = {};

      if (!qString) {
        return paramObj;
      }

      qString = qString.split('#')[0];

      var parts = qString.split('&');

      parts.forEach(el => {
        var keyVal = el.split('=');
        var pName = keyVal[0];
        var pVal = typeof (keyVal[1]) === 'undefined' ? true : keyVal[1];

        pName = pName.toLowerCase();

        if (!paramObj[pName]) {
          paramObj[pName] = pVal;
        }
      });

      return paramObj;

    }

    /** function to invoke at form change event **/
    checkFormChangeEvent = function (elem) {
      try {
        if (formChanged === false && elem.nodeName.toLowerCase() == 'form') {
          // setting variable state here at the first change.
          formChanged = true;
          // push Data Layer once here
          _utilPushDataLayer('formChanged', elem);
        }
      }
      catch (e) {
        console.error(e.name + ' : ' + e.message);
      }
    }


    /** handle form submit **/
    pushGTMSubmit = function (elem) {
      try {
        if (elem.nodeName && elem.nodeName.toLowerCase() == 'form') {
          _utilPushDataLayer('formSubmissionSuccess', elem);
        }
      }
      catch (e) {
        console.error('dLayerFunc pushGTMSubmit failed at check elem!');
      }

    }

    /** handle submit with error/empty values **/
    pushGTMFailed = function (elem) {
      try {
        if (elem.nodeName && elem.nodeName.toLowerCase() == 'form') {
          _utilPushDataLayer('formSubmissionFailed', elem);
        }
      }
      catch (e) {
        console.error('dLayerFunc pushGTMFailed failed at check elem!');
      }

    }

    /** handle user consent / optin **/
    pushGTMConsent = function (elem) {
      try {
        if (elem.nodeName && elem.nodeName.toLowerCase() == 'form') {

          let checkBox = elem.querySelector("input[type=checkbox][data-agb]");
          if (checkBox != null && checkBox.checked) {
            _utilPushDataLayer('userOptInStatus', elem, 'Y');
          } else {
            _utilPushDataLayer('userOptInStatus', elem, 'N');
          }

        }
      }
      catch (e) {
        console.error('dLayerFunc pushGTMConsent failed at check elem!');
      }
    }

    /** utility to push to data layer **/
    function _utilPushDataLayer(eventString, formElement, consentValue = null) {
      let _formID = formElement.getAttribute('formid') || 'no-id-supplied-or-detected';
      let _consentValue = consentValue;
      let dLayerObj = {
        event: eventString,
        formId: _formID
      }
      if (consentValue !== null) {
        dLayerObj.optIn = consentValue.toUpperCase();
      }

      GtmUtils.getDataLayer().push(dLayerObj);
    }

    return {
      pushGTMConsent: function (formElement) {
        pushGTMConsent(formElement);
      },
      pushFormSubmit: function (formElement) {
        pushGTMSubmit(formElement);
      },
      pushFormFailed: function (formElement) {
        pushGTMFailed(formElement);

      }
    }

  }
));